import React from "react";
import "../../../../../styles/Pages/Financial/CashInFlow/Grants/CollectGrants.style.css";
import FormInput from "../../../../Universal/FormInput.component";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import { Formik } from "formik";
import MemberFormValidation from "../../../Organizational/Management/Members/MemberFormValidation.component";

const CollectGrants = () => {
  return (
    <div className="CollectGrantsContainer">
      <div className="GrantHeader mb-2">
        <h3>Collect Grants</h3>
      </div>
      <Formik
        initialValues={{
          name: "",
          contact: "",
          address: "",
          pin: "",
          amount: "",
          paymentMode: "",
          receiver: "",
        }}
        validationSchema={MemberFormValidation} // Validation schema
        onSubmit={(values) => {
          console.log("Form Submitted:", values); // Log the values
          // setSubmittedValues(values); // Store the submitted values in state
        }}
      >
        {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => {
          return (
            <form onSubmit={handleSubmit} className="memberForm">
              <div className="memberAddFormRightInputs">
                <div className="memberAddFormTextInputs">
                  <FormInput
                    type="text"
                    name="name"
                    touched={touched}
                    errors={errors}
                    placeholder="Enter full name"
                    label="Name"
                    setFieldValue={(e) => setFieldValue("name", e.target.value)}
                  />
                  <FormInput
                    label="Contact"
                    type="number"
                    name="phone"
                    touched={touched}
                    errors={errors}
                    placeholder="Enter phone number"
                    setFieldValue={(e) =>
                      setFieldValue("contact", e.target.value)
                    }
                  />

                  <FormInput
                    label="Address"
                    type="text"
                    name="address"
                    touched={touched}
                    errors={errors}
                    placeholder="Enter full address"
                    setFieldValue={(e) =>
                      setFieldValue("address", e.target.value)
                    }
                  />
                  <FormInput
                    label="PIN"
                    type="number"
                    name="pin"
                    touched={touched}
                    errors={errors}
                    placeholder="Enter PIN Code"
                    setFieldValue={(e) => setFieldValue("pin", e.target.value)}
                  />
                  <FormInput
                    label="Amount"
                    type="number"
                    name="amount"
                    touched={touched}
                    errors={errors}
                    placeholder="Enter amount"
                    setFieldValue={(e) =>
                      setFieldValue("amount", e.target.value)
                    }
                  />

                  <DropDownInput
                    name="paymentMode"
                    label="Payment Mode"
                    setFieldValue={(val) => setFieldValue("paymentMode", val)}
                    placeholder={"Choose payment mode"}
                    suggestionList={["UPI", "Card", "Cash"]}
                    errors={errors}
                    touched={touched}
                    setTouched={(name, isTouched) =>
                      setTouched({ [name]: isTouched })
                    }
                  />
                  <DropDownInput
                    name="receiver"
                    label="Receiver"
                    setFieldValue={(val) => setFieldValue("receiver", val)}
                    placeholder={"Choose a authorized receiver"}
                    suggestionList={["testwork", "test2 work"]}
                    errors={errors}
                    touched={touched}
                    setTouched={(name, isTouched) =>
                      setTouched({ [name]: isTouched })
                    }
                  />
                  <button type="submit" className="memberFormSubmitBtn">
                    Collect
                  </button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default CollectGrants;
